import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useHeader } from './../../components/HeaderContext';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import useAuth from "./../../hooks/useAuth.js";
import { Select } from 'antd';
import { useAlert } from './../../components/AlertContext.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from "@fortawesome/free-solid-svg-icons"; // import key icon
import OkModal from "./../../components/OkModal.js";

const UsersEdit = () => {

    const { id } = useParams();

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const axiosPrivate = useAxiosPrivate();

    const { auth } = useAuth();
    const ReturnPage = "/users";
    const Utilizador = auth.user ? auth.user : "nodejs";
    const last_modified_user_id = 1;

    const { triggerAlert } = useAlert();

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Edit User");
    }, [setHeader]);


    //para guardar os valores dos campos
    const [formData, setFormData] = useState({
        company_id: '',
        user_id: '',
        username: '',
        password: '',
        confirm_password: '',
        full_name: '',
        group_id: '',
        is_active: '',
        last_modified_date: '',
        last_modified_user_id: last_modified_user_id
    })

    const navigate = useNavigate();


    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    }

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };


    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForSelectGroup();
            await fetchDataForForm();
        };
        fetchData();
    }, []);


    const fetchDataForForm = async () => {
        try {
            console.log("useEffect");
            console.log(id);
            await axiosPrivate.get(`${baseURL}/users/` + id)
                .then(result => {
                    const data = result.data;
                    console.log(result)
                    setFormData({
                        ...formData,
                        company_id: data.company_id,
                        user_id: data.user_id,
                        username: data.username,
                        full_name: data.full_name,
                        group_id: data.group_id,
                        is_active: data.is_active,
                        last_modified_date: data.last_modified_date ? data.last_modified_date.substring(0, 10) + " " + data.last_modified_date.substring(11, 19) : '',
                        last_modified_user_id: data.last_modified_user_id
                    });
                })

        } catch (error) {
            console.error('Error fetching form data:', error);
        }
    };



    const [optionsGroup, setOptionsGroup] = useState([]);
    const fetchDataForSelectGroup = async () => {
        try {
            const response = await axiosPrivate.get(`${baseURL}/group_list`);
            const data = response.data;

            // Update options for React Select
            const selectOptions = data.map(item => ({
                value: item.group_id,
                label: item.group_name + " - " + item.description,
            }));

            setOptionsGroup(selectOptions);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleChangePassword = async () => {
        console.log("handleSubmitEdit", "password: ", formData.password, "confirm_password: ", formData.confirm_password);

        if (!formData.password || !formData.confirm_password) {
            handleShowOkModal("Necessário preencher os campos Password e Confirmar Password!", "warning")
            return; // Stop submission if any field is invalid
        }

        if (formData.password !== formData.confirm_password) {
            handleShowOkModal("As duas password não coincidem!", "warning")
            return; // Stop submission if any field is invalid
        }


        try {
            await axiosPrivate.put(`${baseURL}/utilizadores_reset_password/` + id, formData)
                .then(result => {
                    console.log(result.data);

                    let message = `Record Savded!`;
                    triggerAlert(message, 'success');

                    navigate(ReturnPage);
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err.originalError.info.message);
                        let message = `Error in save!  \n ${err.response.data.err.originalError.info.message}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        let message = `Error in save!`;
                        triggerAlert(message, 'error');
                    }
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleSubmitEdit = async (e) => {
        console.log("handleSubmitEdit");
        e.preventDefault();


        // valida campos cabeçalho
        if (!formData.group_id) {
            handleShowOkModal("Fields to fill in!", "warning")
            return; // Stop submission if any field is invalid
        }


        try {
            await axiosPrivate.put(`${baseURL}/users/` + id, formData)
                .then(result => {
                    console.log(result.data);

                    let message = `Registo Alterado!`;
                    triggerAlert(message, 'success');

                    navigate(ReturnPage);
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err.originalError.info.message);
                        let message = `Erro na gravação!  \n ${err.response.data.err.originalError.info.message}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        let message = `Erro na gravação!`;
                        triggerAlert(message, 'error');
                    }
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }


    };



    const handleChange_group_id = (selectedOption) => {
        if (selectedOption) {
            setFormData({ ...formData, group_id: selectedOption });
        } else {
            setFormData({ ...formData, group_id: '' }); // If the option is cleared
        }
    };



    return (
        <div className="d-flex  align-items-center mt-1">
            <div className="p-2 rounded w-50">
                <form className="row g-1" onSubmit={handleSubmitEdit}>

                    <div className="col-12 d-none">
                        <label className="form-label mt-2 app_font1 required" htmlFor="company_id">company_id</label>
                        <input type="text" name="company_id" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.company_id}
                            onChange={(e) => setFormData({ ...formData, company_id: e.target.value })} />
                    </div>

                    <div className="col-12">
                        <label htmlFor="username" className="form-label mt-2 app_font1 required" >Username</label>
                        <input type="text" name="username" className="form-control form-control-sm app_font1" maxLength="30" required disabled
                            value={formData.username}
                            onChange={(e) => setFormData({ ...formData, username: e.target.value })} />
                    </div>



                    <div className="col-12">
                        <label htmlFor="full_namenome" className="form-label mt-2 app_font1 required" >Full Name</label>
                        <input type="text" name="full_name" className="form-control form-control-sm app_font1" maxLength="100" required
                            value={formData.full_name}
                            onChange={(e) => setFormData({ ...formData, full_name: e.target.value })} />
                    </div>



                    <div className="col-12 mt-2">
                        <div className="d-flex align-items-end">
                            <div className="me-3 flex-grow-1">
                                <label htmlFor="password" className="form-label app_font1">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    className="form-control form-control-sm app_font1"
                                    maxLength="60"
                                    value={formData.password}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                />
                            </div>

                            <div className="me-3 flex-grow-1">
                                <label htmlFor="confirm_password" className="form-label app_font1">Confirm Password</label>
                                <input
                                    type="password"
                                    name="confirm_password"
                                    className="form-control form-control-sm app_font1"
                                    maxLength="60"
                                    value={formData.confirm_password}
                                    onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                                />
                            </div>

                            <button
                                type="button"
                                onClick={() => handleChangePassword()}
                                className="btn"
                                title="Change Password"
                            >
                                <FontAwesomeIcon icon={faKey} className="custom-icon" />
                            </button>
                        </div>
                    </div>








                    <div className="col-5">
                        <label htmlFor="group_id" className="form-label app_font1 mt-2 required"> Group </label>
                        <Select
                            showSearch
                            optionFilterProp="label"
                            onChange={handleChange_group_id}
                            value={optionsGroup.find(option => option.value === formData.group_id)}
                            allowClear
                            style={{ width: '100%' }}
                            options={optionsGroup}
                            className="d-block"
                            required
                        />
                    </div>




                    <div className="col-12 interno">
                        <label className="form-label mt-2 app_font1 required" htmlFor="last_modified_date">last_modified_date</label>
                        <input type="text" name="last_modified_date" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_date}
                            onChange={(e) => setFormData({ ...formData, last_modified_date: e.target.value })} />
                    </div>

                    <div className="col-12 interno">
                        <label className="form-label mt-2 app_font1 required" htmlFor="last_modified_user_id">last_modified_user_id</label>
                        <input type="text" name="last_modified_user_id" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_user_id}
                            onChange={(e) => setFormData({ ...formData, last_modified_user_id: e.target.value })} />
                    </div>


                    <div className="mt-3">
                        <button type='submit' className="btn btn-success" style={{ marginRight: '20px', marginTop: '10px' }}>Save</button>
                        <button className="btn btn-outline-success" style={{ marginRight: '20px', marginTop: '10px' }} onClick={() => navigate(ReturnPage)}>Cancel</button>
                    </div>
                </form>

                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                    header=""
                />


            </div>
        </div>
    )
}

export default UsersEdit